<div class="container mt-5" style="max-width:600px;">

    <h2 class="text-center mb-4">
        Leave a Testimony
    </h2>
  
    <form  [formGroup]="testimonyForm" (ngSubmit)=" submitTestimony()">
         <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
         <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <div class="mb-3">
            <label>Full Name</label>
            <input type="text" class="form-control" formControlName="fullName" required>
        </div>

        <div class="mb-3">
            <label>Comment</label>
            <textarea class="form-control" formControlName="comment" required></textarea>
        </div>
          
       <!-- <div class="rating">
       <i *ngFor="let star of [1,2,3,4,5]" class="fa" [ngClass]="star <= selectedStar ? 'fa-star checked' : 'fa-star-o'" (click)="setRating(star)"></i>
        </div>
        <input type="star" formControlName="star">-->
           <!-- Star Rating -->
  <div class="mb-3">
    <label class="form-label d-block">Rating</label>

    <i
      *ngFor="let star of [1,2,3,4,5]"
      class="fa"
      [ngClass]="star <= selectedStar ? 'fa-star checked' : 'fa-star-o'"
      (click)="setRating(star)"  style="cursor:pointer; font-size:28px;">
    </i>

    <!--<div class="mt-2">
      {{ selectedStar }} / 5
    </div>-->

    <input type="hidden" formControlName="star">
  </div>

     
        <button [disabled]="!testimonyForm.valid" class="btn btn-primary" type="submit" [disabled]="loading"> {{ loading ? 'submitTestimony...' : 'Submit' }}</button>
      

    </form>

   <!-- <div
        *ngIf="message"
        class="alert mt-3"
        [ngClass]="submitted ? 'alert-success' : 'alert-danger'">

        {{ message }}

    </div>-->

</div>
<br>
<br>
